<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2,mb-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title> Add Timesheet</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">

                        <b>Date</b> <v-icon color="error">*</v-icon>
                        <v-text-field :max="new Date().toISOString().substr(0, 10)" color="#0F2027" dense required class="mt-4" v-model="fromdate" label="Date"
                            @change="getdataformtimesheet(fromdate)" type="date" outlined></v-text-field>                        
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>Start Time</b> <v-icon color="error">*</v-icon>
                        <v-text-field color="#0F2027" dense required class="mt-4" v-model="start_time" type="time"
                            label="Start Time" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>End Time</b> <v-icon color="error">*</v-icon>
                        <v-text-field color="#0F2027" dense required class="mt-4" v-model="end_time" label="End Time"
                            type="time" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>Task</b> <v-icon color="error"></v-icon>
                        <v-text-field color="#0F2027" dense required class="mt-4" v-model="new_task" label="Task"
                            outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" class="mt-11 ml-10">
                        <b>OR</b> <v-icon color="error"></v-icon>
                    </v-col>

                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>Task</b> <v-icon color="error"></v-icon>
                        <v-autocomplete color="#0F2027" dense class="mt-4" v-model="task" item-value="id"
                            :items="timesheettaskmasterlist" item-text="name" label="Task" outlined />
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                        <v-icon color="primary" class="pt-12 mt-2 ml-3" @click="gotomaster()">mdi-plus-circle</v-icon>

                    </v-col>

                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <b>Description</b> <v-icon color="error"></v-icon>
                        <v-textarea v-model="description" label="Description" outlined dense class="mt-4"></v-textarea>
                    </v-col>

                </v-row>
                <v-row justify="center">
                    <v-btn class="mr-4" :loading="saveloader" color="primary" @click="saveTimesheetTask"
                        v-if="fromdate && start_time && end_time && (task || new_task)">
                        Save
                    </v-btn>
                </v-row>
                <v-card class="box" v-if="get_timesheet_list.length > 0">

                    <v-col cols="6" sm="2" md="2">
                        <v-btn class="ma-2 no-display " rounded color="success" outlined
                            v-if="get_timesheet_list.length != 0" @click="fnExcelReport('my-table-id', 'Timesheet')"
                            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <div id="my-table-id">
                        <v-data-table :headers="headers" :items="get_timesheet_list">
                            <template v-slot:top>
                                <v-toolbar flat class="toolbar">
                                    <v-toolbar-title>Time Sheet</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.description`]="{ item }">
                                <div v-if="item.description != null">
                                    <v-icon medium class="mr-2" @click="getdescription(item.description)">
                                        mdi-eye-outline</v-icon>
                                </div>
                                <div v-else>
                                    --
                                </div>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div>
                                    <v-avatar size="25" class="edit-avatar">
                                        <v-icon class="mr-2 edit-v-icon" @click="editTimesheet(item)"
                                            title="edit">edit</v-icon>
                                    </v-avatar>
                                </div>
                            </template>
                            <template v-slot:[`item.delete`]="{ item }">
                                <div>
                                    <v-avatar size="25" class="edit-avatar">
                                        <v-icon class="mr-4 v-icon-size" color="red" @click="deleteTImesheet(item)"
                                            :loading="delete_load">mdi-trash-can</v-icon>
                                    </v-avatar>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </v-card>

                <v-dialog v-model="dialogshowdescription" max-width="1200px">
                    <v-card class="box">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title class="px-0">Description</v-toolbar-title>

                        </v-toolbar>

                        <v-card-text>

                            <strong>
                                {{ showdescription }}
                            </strong>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn class="dialog-btn" @click="dialogshowdescription = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog" max-width="500px">

                    <v-card>
                        <v-card-title class="toolbar">
                            <span class="headline">Edit Time Sheet</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12" md="12">
                                        <b>Date</b> <v-icon color="error">*</v-icon>
                                        <v-text-field color="#0F2027" dense required class="mt-4" :max="new Date().toISOString().substr(0, 10)"
                                            v-model="edititem.fromdate" label="Date" type="date" outlined>
                                        </v-text-field>

                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <b>Start Time</b> <v-icon color="error">*</v-icon>
                                        <v-text-field color="#0F2027" dense required class="mt-4"
                                            v-model="edititem.start_time" type="time" label="Start Time"
                                            outlined></v-text-field>

                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <b>End Time</b> <v-icon color="error">*</v-icon>
                                        <v-text-field color="#0F2027" dense required class="mt-4"
                                            v-model="edititem.end_time" label="End Time" type="time"
                                            outlined></v-text-field>

                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                        <b>Task</b> <v-icon color="error"></v-icon>
                                        <v-text-field color="#0F2027" dense required class="mt-4"
                                            v-model="edititem.new_task" label="Task" outlined></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="justify-center">
                                    <h3>OR</h3>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="12">
                                        <b>Task</b> <v-icon color="error"></v-icon>
                                        <v-autocomplete color="#0F2027" dense class="mt-4" v-model="edititem.task"
                                            item-value="id" :items="timesheettaskmasterlist" item-text="name"
                                            label="Task" outlined />
                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                        <b>Description</b> <v-icon color="error"></v-icon>
                                        <v-textarea v-model="edititem.description" label="Description" outlined dense
                                            class="mt-4"></v-textarea>

                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button" @click="close">Cancel</v-btn>
                            <v-btn class="button" @click="editTimesheetTask">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </v-card>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Add TimeSheet Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/NwgaSNYyz8E?si=YPfBY-uZ3eRlCnCp"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
    data: () => ({

        loader: false,
        snackbar_msg: "",
        search: "",
        basepath: null,
        showdescription: null,
        laddress: true,
        dialog: false,
        dialogshowdescription: false,
        color: "",
        snackbar: false,
        videoDialog:false,
        overlay: false,
        delete_load: false,
        saveloader: false,
        editloader: false,
        edititem: {
        },
        fromdate: new Date().toISOString().slice(0, 10),
        timesheettaskmasterlist: [],
        get_timesheet_list: [],
        start_time: "",
        end_time: "",
        description: "",
        task: "",
        new_task: "",

        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Date", value: "fromdate" },
            { text: "Start Time", value: "start_time" },
            { text: "End Time", value: "end_time" },
            { text: "Task", value: "task" },
            { text: "Description", value: "description" },
            { text: "Action", value: "action" },
            { text: "Delete", value: "delete" },
        ],


       


    }),
    computed: {
      
      
    },

    methods: {
        gotomaster() {
            
            let routeData = this.$router.resolve({ name: "task-master" });
            window.open(routeData.href, "_blank");
        },
       
        close() {
           
            this.edititem = {};
            this.dialog = false;
        },
        editTimesheet(taskData) {
            

            let matchedTask = this.timesheettaskmasterlist.find(t => t.name === taskData.task);

            // Ensure fromdate is valid
            let formattedDate = "";
            if (taskData.fromdate) {
                let parts = taskData.fromdate.split("/");  // Split "DD/MM/YYYY"
                if (parts.length === 3) {
                    formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // Convert to "YYYY-MM-DD"
                } else {
                    console.error("Invalid fromdate format:", taskData.fromdate);
                }
            }

            this.edititem = {
                id: taskData.id,
                fromdate: formattedDate,  // Corrected date format
                start_time: taskData.start_time,
                end_time: taskData.end_time,
                description: taskData.description,
                task: matchedTask ? matchedTask.id : null,
                new_task: matchedTask ? "" : taskData.task
            };

           

            this.dialog = true; // Open the edit dialog
        },
        editTimesheetTask() {
            if (this.edititem.start_time >= this.edititem.end_time) {
                this.showSnackbar("red", "Start Time must be less than End Time...!");
                return;
            }
            
            this.editloader = true;
            axios
                .post("/Timesheet/editTimesheetTask", this.edititem)
                .then((res) => {
                    if (res.data.flag == "YES") {

                        this.showSnackbar("green", "TimeSheet Update succesfully....!");
                        this.onLoad();
                        this.dialog = false;
                        this.fromdate= new Date().toISOString().slice(0, 10)

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.editloader = false;
                        this.dialog = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.editloader = false;
                    this.dialog = false;
                })
                .finally(() => { });
            this.editloader = false;
            this.dialog = false;
        },
        deleteTImesheet(item) {
           
            let data= {
                id:item.id,
            }
            this.delete_load = true;
            axios
                .post("/Timesheet/deleteTimesheetTask", data)
                .then((res) => {
                    if (res.data.flag == "YES") {

                        this.showSnackbar("green", "TimeSheet Deleted succesfully....!");
                        this.onLoad();
                       
                        this.fromdate = new Date().toISOString().slice(0, 10)

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.delete_load = false;
                      
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.delete_load = false;
                   
                })
                .finally(() => { });
            this.delete_load = false;
            
        },
       fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getdescription(description) {
            this.showdescription = description;
            this.dialogshowdescription = true;
        },
        onLoad() {
          
            axios
                .post("/Timesheet/getTimesheetTaskMasterList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.timesheettaskmasterlist = res.data.timesheettaskmasterlist;
                        this.get_timesheet_list = res.data.get_timesheet_list;


                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        saveTimesheetTask() {
            if (this.start_time >= this.end_time) {
                this.showSnackbar("red", "Start Time must be less than End Time...!");
                return;
            }
            let data = {
                fromdate: this.fromdate,
                start_time: this.start_time,
                end_time: this.end_time,
                new_task: this.new_task,
                description: this.description,
                task: this.task,
            };
            this.saveloader = true;
            axios
                .post("/Timesheet/saveTimesheetTask", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        
                        this.showSnackbar("green", "TimeSheet Added added succesfully....!");
                        this.onLoad();
                        this.new_task="",
                            this.task ="",
                            this.description ="",
                            this.start_time ="",
                            this.end_time = "",
                            this.fromdate= new Date().toISOString().slice(0, 10),
                        this.saveloader = false;

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.saveloader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.saveloader = false;
                })
                .finally(() => { });
            this.saveloader = false;
        },
        getdataformtimesheet(date) {
            const data = {
                date: date,
            }
            axios
                .post("/Timesheet/getTimesheetTaskMasterList", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.get_timesheet_list = res.data.get_timesheet_list;


                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {

    },
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .button1 {
        border: 2px solid white !important;
        color: #1196cf;
        margin: 0.5rem !important;
        background-color: lightgray !important;
    }

    .button1:hover {
        color: white !important;
        background: #ffc200 !important;
        background: #0f2027;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right,
                #2c5364,
                #203a43,
                #0f2027);
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}

.sign {
    padding-left: 855px !important;
}



/* Table Header Styling */



/* Table Rows */
</style>
